import React from "react";
import "./policies.css";

function Policies() {
  return (
    <div className="policies">
      <div>
        <h3>Terms & Conditions</h3>
        <ul>
          <li>
            Madhwapaaka does not encourage order cancellations, return or
            exchange of any items.
          </li>
          <li>
            Madhwapaaka is not to be held responsible for any kind of delay
            caused by the shipping agents.
          </li>
          <li>
            Madhwapaaka is not to be held responsible for any kind of
            mishandling by the shipping agents.
          </li>
        </ul>
      </div>
      <div>
        <h3>Refund/Cancellation Policy</h3>
        <p>
          Refunds for failed transactions will be completed in 2-3 business
          days. As of now, Madhwapaaka does not encourage order cancellations,
          return or exchange of any items.
        </p>
      </div>
      <div>
        <h3>Privacy Policy</h3>
        <p>
          The details entered by the user during the order and the payment is
          strictly confidential and is not available to any other third parties
          through code inspection.
        </p>
      </div>
      <div>
        <h3>Shipping Policy</h3>
        <p>
          Our shipping partners deliver your orders in 3-4 business days if the
          delivery location is in Karnataka or 4-5 business days if the delivery
          location is outside Karnataka.
        </p>
      </div>
    </div>
  );
}

export default Policies;
